import Queries from './Queries';

export default Queries;
